// src/common/YearDropdown.tsx
import React, { useEffect } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";

interface Props {
  title: string;
  onSelect: (value: number, label: string) => void;
  size?: "sm" | "lg";
  variant?: string;
  stopPropagation?: boolean;
  show?: boolean;
  onToggle?: (isOpen: boolean) => void;
}

const generateYears = () => {
  const years = [];
  for (let i = 2025; i <= 2100; i++) {
    years.push({ label: i.toString(), value: i });
  }
  return years;
};

const YearDropdown: React.FC<Props> = ({
  title,
  onSelect,
  size = "sm",
  variant = "outline-secondary",
  stopPropagation = false,
  show,
  onToggle,
}) => {
  const years = generateYears();

  useEffect(() => {
    const handleScroll = (e: any) => {
      const dropdownMenu = document.querySelector(".year-dropdown-menu");

      if (dropdownMenu && dropdownMenu.contains(e.target)) {
        return;
      }

      if (show) {
        onToggle?.(false);
      }
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [show, onToggle]);

  return (
    <DropdownButton
      size={size}
      variant={variant}
      title={<span>{title}</span>}
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      show={show}
      onToggle={onToggle}
      style={{ position: "relative" }}
      align="end"
    >
      <div
        className="year-dropdown-menu"
        style={{
          maxHeight: "200px",
          overflowY: "auto",
        }}
      >
        {years.map((item) => (
          <Dropdown.Item
            key={item.value}
            onClick={() => onSelect(item.value, item.label)}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </div>
    </DropdownButton>
  );
};

export default YearDropdown;
